// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oVaq","colBig":"styles_colBig__foD1f","colSmall":"styles_colSmall__2U6Fb"};